import createRoute from '@widesk-ui/tools/createRoute';
import OrderModel  from '@models/shop/OrderModel';

export default createRoute.dashboard('/entertainments/:entertainmentId/orders', 'shop', 'OrderDashboard', OrderModel.localize());
